import * as React from 'react';
import {Tooltip} from 'components/ui/Tooltip';
import {MessageCircle, MessageCircleDashed} from 'lucide-react';

export default function ListItemComments({comments = ''}) {
	const hasComments = comments.length > 0;

	const icon = (
		<div className="flex items-center gap-x-2">
			{hasComments ? (
				<MessageCircle size={16} className="text-gray-600" />
			) : (
				<MessageCircleDashed className="text-gray-300" size={16} />
			)}
		</div>
	);

	return (
		<div
			className="flex flex-wrap items-center gap-2 h-full"
			onClick={e => e.stopPropagation()}
		>
			{hasComments ? (
				<Tooltip placement="top" size="sm" trigger={icon}>
					<div className="max-w-[200px] break-words">{comments}</div>
				</Tooltip>
			) : (
				icon
			)}
		</div>
	);
}
